import React, { useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";
import Checkbox from "@mui/material/Checkbox";
import { IconButton } from "@mui/material";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import {
  Table,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
} from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function RejectRequestModal({ req }) {
  const [open, setOpen] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCheck = (e) => {
    setIsChecked(!isChecked);
  };

  const handleRejectReq = (id) => {
    axios({
      method: "post",
      url: process.env.REACT_APP_OP_STATUS_URL,
      data: {
        ID: id,
        status: "REJECTED",
      },
      headers: {
        "X-Api-Key": process.env.REACT_APP_X_API_KEY,
        "Access-Control-Allow-Origin": "*",
      },
    }).then(() => {
      setOpenToast(true);
      if (id.includes("mint")) {
        return axios({
          method: "post",
          url: `${process.env.REACT_APP_RELEASE_MINT_URL}/${id}`,
          headers: {
            "X-Api-Key": process.env.REACT_APP_X_API_KEY,
            "Access-Control-Allow-Origin": "*",
          },
        }).then(() => {
          console.log("Mint request released succesfully");
          window.location.reload();
        });
      } else {
        return axios({
          method: "post",
          url: `${process.env.REACT_APP_RELEASE_BURN_URL}/${id}`,
          headers: {
            "X-Api-Key": process.env.REACT_APP_X_API_KEY,
            "Access-Control-Allow-Origin": "*",
          },
        }).then(() => {
          console.log("Burn request released succesfully");
          window.location.reload();
        });
      }
    });
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openToast}
          autoHideDuration={6000}
          onClose={handleCloseToast}
        >
          <Alert
            onClose={handleCloseToast}
            severity="success"
            sx={{ width: "100%" }}
          >
            Transaction request rejected!
          </Alert>
        </Snackbar>
        <Button
          variant="contained"
          onClick={handleOpen}
          sx={{
            backgroundColor: "#f05a25",
            "&:hover": { backgroundColor: "#f05a25" },
          }}
          startIcon={<ClearIcon />}
        >
          Reject
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="bg-white   mt-20 w-2/3 h-1/2 flex flex-col ml-60 ">
            <div className="flex justify-between bg-[#ec644c]  align-baseline">
              <h3 className="text-gray-700 text-2xl mt-1 ml-2">
                Reject Request
              </h3>
              <IconButton onClick={handleClose}>
                <CloseSharpIcon />
              </IconButton>
            </div>
            <Typography id="modal-modal-description">
              <div className="">
                <div className="break-keep">
                  <div className="bg-gray-300">
                    <h3 className="text-gray-700 text-lg mt-1 ml-2">
                      Request Details
                    </h3>
                  </div>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableBody>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Request ID
                          </TableCell>
                          <TableCell>{req.ID}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Account ID
                          </TableCell>
                          <TableCell>{req.accountID}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Request Type
                          </TableCell>
                          <TableCell>
                            {req.ID.includes("mint") ? (
                              <>
                                <ArrowDownwardIcon
                                  sx={{
                                    marginRight: 1,
                                    marginTop: 1,
                                    color: "#3cafa4",
                                  }}
                                />
                                Deposit
                              </>
                            ) : (
                              <>
                                <ArrowUpwardIcon
                                  sx={{
                                    marginRight: 1,
                                    marginTop: 1,
                                    color: "#f05a25",
                                  }}
                                />
                                Withdraw
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Amount
                          </TableCell>
                          <TableCell>{req.amount}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Requested
                          </TableCell>
                          <TableCell>{req.assocComData}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div className=" flex justify-center">
                    <Checkbox onChange={(e) => handleCheck(e)} />
                    <h1 className="mt-2">
                      I have reviewed and responsibly reject the transaction.{" "}
                    </h1>
                  </div>
                </div>
                <div className="flex justify-center">
                  {isChecked ? (
                    <Button
                      variant="contained"
                      onClick={() => handleRejectReq(req.ID)}
                      style={{
                        backgroundColor: "#39b44a",
                        "&:hover": { backgroundColor: "#39b44a" },
                      }}
                      startIcon={<ClearIcon />}
                    >
                      Reject
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      disabled={true}
                      startIcon={<ClearIcon />}
                    >
                      Reject
                    </Button>
                  )}
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
      </Stack>
    </div>
  );
}
